import React, { Component } from "react";
import { Row, Col } from "reactstrap";

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <div className="container-fluid">
            <Row>
              <Col sm={6}></Col>
              <Col sm={6}>
                <a href="https://hoomaan.net" target="_blank" rel="noreferrer">
                  <div className="text-sm-end d-none d-sm-block">
                    {new Date().getFullYear()} Design & Develop by © Hoomaan
                  </div>
                </a>
              </Col>
            </Row>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
